<template>
  <div>
    <div :class="`alert alert-default`">
      <div class="container">
        <el-button type="button" aria-hidden="true" icon="el-icon-close" class="close" @click="close">
        </el-button>
        <div>
          <router-link v-for="item in data" :key="item.claimId" style="
            color: white;
            display: inline-block;
            font-size: var(--font-medium);
            padding-right: 10px;
            padding-top: 5px;
            padding-bottom: 5px;
            font-weight: normal;
          " :target="readonly ? '' : '_blank'" :to="
            readonly
              ? ''
              : path(
                  item.claimId ? item.claimId : item.id,
                  item.claimId ? 'claim' : 'accident'
                )
          ">
            <span :class="item.uid === 5 ? 'personal' : ''">
              {{ item.number }}
            </span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
    };
  },
  props: {
    name: String,
    pathname: String,
    readonly: { type: Boolean, default: false },
  },
  methods: {
    path(val, name) {
      return this.pathname + "/" + name + "/" + val;
    },
    close() {
      this.$emit("close", null);
    },
  },
};
</script>

<style scoped>
.alert {
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  border-radius: 5px 5px 5px;
  background-color: #607d8b;
}

.personal {
  color: white;
  background-color: #f57c00;
  padding: 5px;
  border-radius: 5px 5px 5px;
  border: 1px solid 0ffa45;
}
.alert button.close {
  position: absolute;
  top: 65%;
  right: 10px;
  transform: translateY(-50%);
  z-index: 3;

  width: 25px;
  height: 25px;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
}


</style>